<div class="search-bar-wrap">
	<ion-input
		class="ion-no-padding ion-no-margin"
		[value]="inputValue"
		(ionChange)="searchChanged($event)"
		debounce="300"
		slot="fixed"
	></ion-input>

	<ion-buttons slot="end">
		<ion-button class="ion-no-margin" (click)="cancelSearch()">Cancel</ion-button>
	</ion-buttons>
</div>
